import { render } from "./B2bTableMenuDocumentacionDocumentos.vue?vue&type=template&id=edd2d6ee&scoped=true&lang=pug"
import script from "./B2bTableMenuDocumentacionDocumentos.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuDocumentacionDocumentos.vue?vue&type=script&lang=js"

import "./B2bTableMenuDocumentacionDocumentos.vue?vue&type=style&index=0&id=edd2d6ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edd2d6ee"]])

export default __exports__